<template>
	<div v-if="initiated">

			<div v-for="(bubble, index) in sortedBubbles" :key="bubble.id" class="pb-3 chat-bubble" :id="'bubble-activator-btn__' + bubble.id">
				<v-menu
					top
					:close-on-content-click="false"
					:close-on-click="false"
					:nudge-left="offsets[index]"
					nudge-bottom="25"
					left
					:value="sortedBubbles[index].bubble_expanded"
					attach="#chat__bubbles-hook"
					:min-width="popupWidth"
					:max-width="popupWidth"

				>

					<template v-slot:activator="{on}">
						<v-badge
							z-index="1"
							overlap
							bordered
							top
							offset-y="-10"
							offset-x="-40"
							color="red"
							:style="bubble.unread_messages_count ? 'opacity: 1; z-index: 1' : 'opacity: 0'"
							width="20"
							:content="bubble.unread_messages_count"
						/>
						<v-badge
							v-if="bubble.is_public"
							overlap
							bottom
							left
							offset-y="-5"
							offset-x="-40"
							style="z-index: 1"
							class="badge-public"
							icon="mdi-web"
						/>
						<v-btn v-on="on" class="collapse" />
						<v-tooltip left :open-delay="300">
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									@click="openBubble(bubble)"
									fab
									class="pa-0 chat-bubble"
									:class="{'chat-bubble-inactive' : !bubble.bubble_expanded}"
									>
									<v-avatar
										color="accent"
										size="60"
										v-if="bubble.is_public"
									><v-icon color="white">mdi-account</v-icon></v-avatar>
									<avatar v-else-if="getOtherUsers(bubble).length == 1" :user="getOtherUsers(bubble)[0]" bubble shadow/>
									<avatar v-else :users="getOtherUsers(bubble)" multiple bubble shadow/>
								</v-btn>
							</template>
							{{ getBubbleName(bubble) }}
						</v-tooltip>
					</template>
					<chat-window :chat="bubble" bubble />
				</v-menu>
				<v-btn
					@click="closeBubble(bubble)"
					fab
					width="20"
					height="20"
					color="primary"
					class="chat-close-bubble-btn">
						<v-icon x-small>mdi-close</v-icon>
				</v-btn>
			</div>

		<div id="chat__bubbles-hook" class="absolute"></div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import _ from 'lodash';
import ChatWindow from '@/components/chat/ChatWindow';
import Avatar from '@/components/Avatar';
import {getOtherUsers, getChatName} from '@/functions/chat';
export default {
	components: {
		ChatWindow,
		Avatar
	},
	data() {
		return {
			expanded: [],
			expandedWidth: 0,
			windowSize: {},
			initiated: false,
		}
	},
	watch: {
		totalExpandedWidth: function(newVal) {
			this.$store.commit('chat/setTotalExpandedWidth', newVal);
		},
	},
	computed: {
		...mapGetters({
			user: 'auth/user',
			quickmenu: 'chat/quickmenu',
			popupWidth: 'chat/popupWidth',
			popupPadding: 'chat/popupPadding',
			activeBubble: 'chat/activeBubble',
			rooms: 'chat/rooms',
			bubbleRooms: 'chat/bubbleRooms',
		}),
		sortedBubbles() {
			return _.orderBy(this.bubbleRooms, 'bubble_added', 'desc')
		},
		expandedBubbles() {
			return this.sortedBubbles.filter(x => x.bubble_expanded);
		},
		offsets() {
			let arr = [];
			let current_offset = 0;
			let expanded_counter = 0;

			this.sortedBubbles.forEach((x, index) => {
				if(x.bubble_expanded) {
					expanded_counter++;
					if(expanded_counter == 1 && this.quickmenu) {
						current_offset += this.popupWidth + this.popupPadding;
					}
					if(expanded_counter > 1) {
						current_offset += this.popupWidth;
					}
					else {
						current_offset -= 10;
					}
					current_offset += this.popupPadding;
					arr[index] = current_offset;
				}
				else {
					arr[index] = 0;
				}
				this.expandedWidth = current_offset;
			});
			return arr;
		},
		totalExpandedWidth() {
			let width = 0;
			if(document.getElementById('chat__bubbles-container')) {
				width += window.innerWidth - document.getElementById('chat__bubbles-container').offsetLeft;
			}

			this.sortedBubbles.forEach(x => {
				if(x.bubble_expanded) {
					width += this.popupWidth + this.popupPadding;
				}
			});
			if(this.quickmenu) {
				width += this.popupWidth + this.popupPadding;
			}

			return width;
		}
	},
	methods: {
		getBubbleName(room) {
			return getChatName(this.user, room);
		},
		openBubble(bubble) {
			//  $vuetify.breakpoint.width

			let index = this.sortedBubbles.findIndex(x => x.id == bubble.id);
			if(index != -1) {
				if(!this.sortedBubbles[index].bubble_expanded) {
					// Check if window width allow to open another bubble
					if(this.$vuetify.breakpoint.width > this.totalExpandedWidth + this.popupWidth + this.popupPadding) {
						this.$store.commit('chat/expandBubble', bubble)
					}
					else {
						// Error!
						this.$store.commit('chat/setPopupRoomNotFitting', bubble);
						// this.$snackbar.error( this.$vuetify.lang.t('$vuetify.views.chat.errors.tooManyExpanded'));
					}
				}

				setTimeout(() => {
						this.$store.commit('chat/setBubbleActive', bubble)
					}, 250)

			}


		},
		closeBubble(bubble) {
			this.$store.commit('chat/removeBubble', bubble);
		},
		getOtherUsers(bubble) {
			return getOtherUsers(this.user, bubble);
		},
	},
	mounted() {
		this.initiated = true;
	}
}
</script>

<style lang="scss">
.chat-bubble {
	position: relative
}

.chat-bubble-inactive {
	.v-avatar {
		opacity: 0.5
	}
}
	.chat-close-bubble-btn{
		position: absolute;
		bottom: 12px;
		right: -5px;
	}
</style>
